
import { useEffect } from "react";
import { useCampaignInit } from "@/hooks/campaign/hooks/useCampaignInit";
import { CampaignNameDialog } from "./components/CampaignNameDialog";
import { DraftsCard } from "./components/landing/DraftsCard";
import { CreateCampaignCard } from "./components/landing/CreateCampaignCard";
import { ClientDashboardCard } from "./components/landing/ClientDashboardCard";
import { useAuth } from "@/contexts/AuthContext";

export const CampaignLanding = () => {
  const {
    loading,
    drafts,
    showNameDialog,
    setShowNameDialog,
    handleCreateCampaign,
    handleNameSubmit,
    loadDrafts
  } = useCampaignInit();

  const { user } = useAuth();

  // Force refresh drafts when component mounts and when user changes
  useEffect(() => {
    if (user) {
      console.log('CampaignLanding: User available, loading drafts for user:', user.id);
      loadDrafts();
    } else {
      console.log('CampaignLanding: No user available');
    }
  }, [loadDrafts, user]);

  // Function to refresh drafts
  const refreshDrafts = () => {
    console.log('CampaignLanding: Manual refresh requested');
    loadDrafts();
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-6">
        <div data-tour="campaign-create">
          <CreateCampaignCard onCreateCampaign={handleCreateCampaign} />
        </div>

        <div data-tour="campaign-drafts">
          <DraftsCard 
            drafts={drafts} 
            loading={loading} 
            onRefresh={refreshDrafts}
          />
        </div>
      </div>

      <div className="mt-6" data-tour="campaign-dashboard">
        <ClientDashboardCard />
      </div>

      {/* Campaign Name Dialog */}
      <CampaignNameDialog
        open={showNameDialog}
        onOpenChange={setShowNameDialog}
        onNameSubmit={handleNameSubmit}
      />
    </>
  );
};
